import { MenuRedirectType, type MenuRedirectConfig } from '../types';

/** Resolve o href da dinâmica de redirecionamento padrão (mesma regra do IconCards). */
export const resolveRedirectHref = (r?: MenuRedirectConfig): string | undefined => {
  if (!r) return undefined;
  if (r.type === MenuRedirectType.EXTERNAL_URL) return r.url || undefined;
  if (r.type === MenuRedirectType.PAGE) return r.pageSlug ? `/${r.pageSlug.replace(/^\//, '')}` : undefined;
  if (r.type === MenuRedirectType.SCROLL_TO_BLOCK) return r.blockId ? `#${r.blockId}` : undefined;
  return undefined;
};

export const resolveRedirectTarget = (r?: MenuRedirectConfig): '_blank' | undefined =>
  r?.type === MenuRedirectType.EXTERNAL_URL && r.openInNewTab ? '_blank' : undefined;
